var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAcessible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.5001C16.9706 21.5001 21 17.4707 21 12.5001C21 7.52956 16.9706 3.50012 12 3.50012C7.02944 3.50012 3 7.52956 3 12.5001C3 17.4707 7.02944 21.5001 12 21.5001Z",
    stroke: "#0052A3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.5001C16.9706 21.5001 21 17.4707 21 12.5001C21 7.52956 16.9706 3.50012 12 3.50012C7.02944 3.50012 3 7.52956 3 12.5001C3 17.4707 7.02944 21.5001 12 21.5001Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 17.0001L12 14.0001M12 14.0001L14 17.0001M12 14.0001V12.0001M12 12.0001L15 11.0001M12 12.0001L9 11.0001",
    stroke: "#0052A3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 17.0001L12 14.0001M12 14.0001L14 17.0001M12 14.0001V12.0001M12 12.0001L15 11.0001M12 12.0001L9 11.0001",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.50012C12.2761 8.50012 12.5 8.27627 12.5 8.00012C12.5 7.72398 12.2761 7.50012 12 7.50012C11.7239 7.50012 11.5 7.72398 11.5 8.00012C11.5 8.27627 11.7239 8.50012 12 8.50012Z",
    fill: "#0052A3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.50012C12.2761 8.50012 12.5 8.27627 12.5 8.00012C12.5 7.72398 12.2761 7.50012 12 7.50012C11.7239 7.50012 11.5 7.72398 11.5 8.00012C11.5 8.27627 11.7239 8.50012 12 8.50012Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.50012C12.2761 8.50012 12.5 8.27627 12.5 8.00012C12.5 7.72398 12.2761 7.50012 12 7.50012C11.7239 7.50012 11.5 7.72398 11.5 8.00012C11.5 8.27627 11.7239 8.50012 12 8.50012Z",
    stroke: "#0052A3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.50012C12.2761 8.50012 12.5 8.27627 12.5 8.00012C12.5 7.72398 12.2761 7.50012 12 7.50012C11.7239 7.50012 11.5 7.72398 11.5 8.00012C11.5 8.27627 11.7239 8.50012 12 8.50012Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcessible);
export default __webpack_public_path__ + "static/media/Acessible.1be16bea4bcc17fa057667e88dad972e.svg";
export { ForwardRef as ReactComponent };